import Vue from 'vue'
import axios from 'axios'


const defaultConfig = {
  // baseUrl: '/',
  limit: 24,
  query: {},
  offsetParameter: '_offset',
  limitParameter: '_limit'
}


const clearParams = (params) => {
  return Object
    .keys(params)
    .reduce((memo, key) => {
      if (params[key] && params[key] != '') memo[key] = params[key]
      return memo
    }, {})
}

export default (config = {}) => {
  config = {...defaultConfig, ...config}
  return {
    namespaced: true,
    state: {
      config,
      query: {},
      items: [],
      page: 1,
      loading: false,
      error: null
    },
    actions: {
      async configure ({ state, commit }, configData = {}) {
        commit('UPDATE_CONFIG', configData)
      },
      async search ({ state, commit, dispatch }, query) {
        try {
          commit('SEARCHING', true)
          if (query) dispatch('updateQuery', query)
          const params = clearParams(state.query)
          params[state.config.limitParameter] = state.config.limit
          params[state.config.offsetParameter] = (state.page - 1) * state.config.limit
          const result = await axios.get(state.config.baseUrl, {params})
          commit('SEARCH_SUCCESS', result)
          return result.data
        } catch (err) {
          console.error('[collection error]', err)
          commit('ERROR', err)
        } finally {
          commit('SEARCHING', false)
        }
      },
      initialize ({ state, commit, dispatch }, config = {}) {
        commit('UPDATE_PAGE', 1)
        dispatch('configure', config)
        return dispatch('search')
      },
      reset ({ state, commit, dispatch }) {
        commit('RESET')
      },
      go ({ state, commit, dispatch }, page) {
        commit('UPDATE_PAGE', page)
        return dispatch('search')
      },
      next ({ state, commit, dispatch }) {
        commit('UPDATE_PAGE', state.page + 1)
        return dispatch('search')
      },
      prev ({ state, commit, dispatch }) {
        commit('UPDATE_PAGE', state.page - 1)
        return dispatch('search')
      },
      updateQuery ({ state, commit }, query = {}) {
        commit('UPDATE_QUERY', { ...state.config.query, ...query })
      },
      updatePage ({ commit }, page) {
        commit('UPDATE_PAGE', page)
      }
    },
    mutations: {
      UPDATE_CONFIG (state, config) {
        Vue.set(state, 'config', { ...state.config, ...config })
      },
      SEARCHING (state, value) {
        state.loading = value
      },
      ERROR (state, err = '') {
        Vue.set(state, 'error', err.message || err.toString())
      },
      SEARCH_SUCCESS (state, axiosResult) {
        Vue.set(state, 'items', axiosResult.data)
      },
      UPDATE_QUERY (state, query) {
        Vue.set(state, 'query', query)
      },
      UPDATE_PAGE (state, page) {
        state.page = page
      },
      RESET (state) {
        Vue.set(state, 'config', config)
        Vue.set(state, 'query', {})
        Vue.set(state, 'items', [])
        Vue.set(state, 'page', 1)
        Vue.set(state, 'loading', false)
        Vue.set(state, 'error', null)
      }
    },
    getters: {}
  }
}


// WEBPACK FOOTER //
// ./src/plugin/collection.js